import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  CompanyProfile,
  CompanyProfileObject,
} from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import companyForm from '@app/forms/subscription/services/companyForm';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: CompanyProfileObject): FormGroup {
    return companyForm.generatForm(entity, this.formBuilder);
  }

  generate(entity: CompanyProfile[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as FormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value.owners);
    formValue.forEach(item => {
      this.transformBeneficialOwner(item);
      this.transformAddresses(item);
    });

    return formValue;
  }
  private transformAddresses(item: any) {
    if (item?.company?.addressSiegeSocial?.country?.value) {
      item.company.addressSiegeSocial.country =
        item.company.addressSiegeSocial.country.value;
    }
    if (item?.company?.addressSiegeAdministratif?.country?.value) {
      item.company.addressSiegeAdministratif.country =
        item.company.addressSiegeAdministratif.country.value;
    }
  }

  private transformBeneficialOwner(item: any) {
    item.company.beneficialOwner.forEach(item => {
      item.address = this.transformAddress(item?.address);
      item.userPhone = this.transformTelephone(item?.userPhone);
    });
  }

  transformAddress(originalAddress: {
    street: string;
    street2?: string;
    zipCode: string;
    city: string;
    country: { id: string; valueGb: string; value: string };
  }) {
    const address = originalAddress
      ? (({ street, street2, city, zipCode, country, ...address }) => ({
          ...address,
          addressStreet: street || '',
          addressStreet2: street2 || '',
          addressCity: city || '',
          addressZipCode: zipCode || '',
          addressCountry: country?.value || '',
        }))(originalAddress)
      : {};
    return address;
  }
  transformTelephone(telephone: any) {
    return telephone?.e164Number;
  }
}
